var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeeltLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.2424 34.9933L29.8811 35.8225C29.6909 35.9384 29.4811 35.9992 29.2681 36C29.0552 36.0008 28.8451 35.9417 28.6542 35.8273L26.4921 34.5313L24.3733 35.8215C24.1826 35.9376 23.9721 35.9983 23.7586 35.9988C23.5451 35.9993 23.3344 35.9395 23.1433 35.8242L21 34.5308L18.8567 35.8242C18.6656 35.9395 18.4549 35.9993 18.2414 35.9988C18.0279 35.9983 17.8175 35.9376 17.6267 35.8215L15.5079 34.5313L13.3458 35.8273C13.1549 35.9417 12.9448 36.0008 12.7319 36C12.519 35.9992 12.3091 35.9384 12.1189 35.8225L10.7577 34.9933C10.5299 34.8546 10.3384 34.6419 10.2046 34.3789C10.0709 34.116 10 33.8131 10 33.5041V8.49586C10 8.18691 10.0709 7.88404 10.2046 7.62107C10.3384 7.3581 10.5299 7.14538 10.7576 7.00666L12.1189 6.17746C12.3091 6.06159 12.5189 6.00084 12.7319 6.00001C12.9448 5.99918 13.1549 6.05829 13.3458 6.17268L15.5079 7.46866L17.6267 6.17855C17.8174 6.06238 18.0279 6.00165 18.2414 6.00119C18.4549 6.00072 18.6656 6.06052 18.8567 6.17585L21 7.46918L23.1433 6.17585C23.3344 6.06052 23.5451 6.00072 23.7586 6.00119C23.9721 6.00165 24.1825 6.06238 24.3733 6.17855L26.4921 7.46866L28.6542 6.17268C28.8451 6.05829 29.0552 5.99918 29.2681 6.00001C29.481 6.00084 29.6909 6.06159 29.8811 6.17746L31.2423 7.00666C31.4701 7.14538 31.6616 7.3581 31.7954 7.62107C31.9291 7.88404 32 8.18691 32 8.49586V33.5042C32 33.8131 31.9291 34.116 31.7953 34.379C31.6616 34.6419 31.4701 34.8546 31.2424 34.9933Z",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26 16H16",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26 21H16",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22 26H16",
    stroke: "#DEB75D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeltLogo);
export default __webpack_public_path__ + "static/media/beelt-logo.e9c3ec90b344044f5e03f678662241f4.svg";
export { ForwardRef as ReactComponent };